import React, { useState, useEffect } from 'react';
import { app } from '../firebase'; // Importez votre configuration Firebase
import { getFirestore, collection, onSnapshot, query, where, orderBy, updateDoc, doc } from 'firebase/firestore'; 
import Loader from '../components/Loader';
import { isCoownership, isRentalManager, useUser } from '../contexts/UserContext';
import { datetimeFromTimestampToString } from '../librairies/Dates';
import PrimaryButton from '../components/buttons/PrimaryButton';
import AddSurvey from './AddSurvey';
import UpdateSurvey from './UpdateSurvey';
import DeleteModal from '../components/modals/DeleteModal';
import DetailsSurvey from './DetailsSurvey';
import ShareButton from '../components/buttons/ShareButton';
import { TEXT_SHARE_SURVEY } from '../helpers/Text';
import { isProvider } from '../contexts/UserContext';
import { rentalManagerCanMakeActionOnCoownership } from '../librairies/UsersLib';
import AppDisplayPreview from '../components/AppDisplayPreview';
import sondagesPreview from '../assets/images/app-display/sondages.jpeg';

const db = getFirestore(app);

const ListSurveys = () => {

  const [surveys, setSurveys] = useState([]); 
  const [loader, setLoader] = useState(true);
  const [showAddSurvey, setShowAddSurvey] = useState(false); 
  const [elementToUpdate, setElementToUpdate] = useState(null);
  const [showUpdateSurvey, setShowUpdateSurvey] = useState(false); 
  const [showArchiveModal, setShowArchiveModal] = useState(false); 
  const [elementToArchive, setElementToArchive] = useState(null); 
  const [selectedSurvey, setSelectedSurvey] = useState(null); // Stocke le sondage sélectionné
  const [activeTab, setActiveTab] = useState('active'); // 'active' ou 'finished'

  //contexte de l'utilisateur connecté
  const user = useUser();

  /**
   * 
   * @param {*} survey 
   * @returns 
   */
  const isSurveyFinished = (survey) => {
    return (Math.floor(Date.now() / 1000) > survey.data().dateEnd.seconds);
  }

  // Séparer les sondages actifs et terminés
  const activeSurveys = surveys.filter(survey => !isSurveyFinished(survey));
  const finishedSurveys = surveys.filter(survey => isSurveyFinished(survey));


  useEffect(() => {
    const collectionRef = collection(db, user.user.userData.lastCoownershipLoaded.path+"/surveys");

    // Ajouter la condition where
    const q = query(collectionRef, where("status", "==", "accepted"), where("statusCreator", "!=", "owner"), orderBy("statusCreator"), orderBy("dateEnd", "desc"));
    //const q = query(collectionRef, where("status", "==", "accepted"), orderBy("dateEnd", "desc"));
    const unsubscribe = onSnapshot(q, (snapshot) => {

      if(snapshot.docs.length > 0){
        
        let arr = [];

        snapshot.docs.map((survey) => {
          if(isProvider(user.user) && survey.data().idCreator.path != "users/"+user.user.user.uid){
            return;
          }

          //on n'affiche pas le sondage s'il est destiné aux membres du CS et que le compte est un rentalManager qui ne peut pas créé de contenu sur la copropriété
          if(isRentalManager(user.user) && !rentalManagerCanMakeActionOnCoownership(user.user) && survey.data().coownershipComiteeTarget && !survey.data().coownerTarget && !survey.data().tenantTarget){
            return;
          }
          arr.push(survey);
        });
        
        setSurveys(arr);
      }else{
        setSurveys([]);
      }

      setLoader(false);
    });

    return () => {
      console.log("unsubscribe surveys");
      unsubscribe();
    }
  }, []); 

  useEffect(() => {
    if(elementToUpdate != null){
      setShowUpdateSurvey(true); 
    }
  }, [elementToUpdate]);

  useEffect(() => {
    if(showUpdateSurvey === false){
      setElementToUpdate(null);
    }
  }, [showUpdateSurvey]);

  useEffect(() => {
    if(elementToArchive != null){
      setShowArchiveModal(true); 
    }
  }, [elementToArchive]);

  useEffect(() => {
    if(showArchiveModal === false){
      setElementToArchive(null);
    }
  }, [showArchiveModal]);

  /**
   * On archive un sondage
   */
  const archiveSurvey = async () => {
    if(elementToArchive !== null){
      const docRef = doc(db, user.user.userData.lastCoownershipLoaded.path+"/surveys/"+elementToArchive);
      await updateDoc(docRef, {
        status: "archived"
      });

      setShowArchiveModal(false);
    }
  }

  // Composant pour afficher un tableau de sondages
  const SurveyTable = ({ surveys, title }) => (
    <div className="relative overflow-x-auto shadow-md sm:rounded-lg">
      <h3 className="text-lg font-semibold mb-4 text-gray-700 dark:text-gray-300">{title}</h3>
      <table className="w-full text-sm text-left text-gray-500 dark:text-gray-400">
        <thead className="text-xs text-gray-700 uppercase bg-gray-50 dark:bg-gray-700 dark:text-gray-400">
          <tr>
            <th scope="col" className="px-6 py-3">
              Titre
            </th>
            <th scope="col" className="px-6 py-3">
              Créé par
            </th>
            <th scope="col" className="px-6 py-3">
              Destiné à
            </th>
            <th scope="col" className="px-6 py-3">
              Nombre de réponses
            </th>
            <th scope="col" className="px-6 py-3">
              Date de création
            </th>
            <th scope="col" className="px-6 py-3">
              Date de fin
            </th>
            {rentalManagerCanMakeActionOnCoownership(user.user) && (
              <th scope="col" className="px-6 py-3">
                Action
              </th>
            )}
          </tr>
        </thead>
        <tbody>
          {surveys.map((survey, key) => {
            return (
              <tr key={key} 
                onClick={() => setSelectedSurvey(survey)}
                className={key % 2 === 0 ? "bg-white border-b dark:bg-gray-900 dark:border-gray-700 dark:text-white text-gray-900 cursor-pointer" : "border-b bg-gray-50 dark:bg-gray-800 text-gray-900 dark:border-gray-700 dark:text-white cursor-pointer"}>
                <td className="px-6 py-4">
                  {survey.data().title}
                </td>
                <td className="px-6 py-4">
                  {survey.data().createdBy}
                </td>
                <td className="px-6 py-4">
                  {survey.data().coownerTarget && "Copropriétaires"}
                  {survey.data().coownerTarget && survey.data().coownershipComiteeTarget && " - "}
                  {survey.data().coownershipComiteeTarget && "Membres du CS"}
                  {(survey.data().coownerTarget || survey.data().coownershipComiteeTarget) && survey.data().tenantTarget && " - "}
                  {survey.data().tenantTarget && "Locataires"}
                </td>
                <td className="px-6 py-4">
                  {survey.data().nbAnswers}
                </td>
                <th scope="row" className="px-6 py-4 font-medium whitespace-nowrap">
                  {datetimeFromTimestampToString(survey.data().dateSave.seconds)}
                </th>
                <th scope="row" className="px-6 py-4 font-medium whitespace-nowrap">
                  {datetimeFromTimestampToString(survey.data().dateEnd.seconds)}
                </th>
                {rentalManagerCanMakeActionOnCoownership(user.user) && (!isRentalManager(user.user) || (isRentalManager(user.user) && survey.data().idCreator.path == "users/"+user.user.user.uid)) && (
                  <td className="px-6 py-4">
                    <div className='flex gap-4'>
                      <a href="#" onClick={(e) => {e.stopPropagation(); setElementToUpdate(survey)}} className="font-medium text-blue-600 dark:text-blue-500 hover:underline">Modifier</a>
                      <a href="#" onClick={(e) => {e.stopPropagation(); setElementToArchive(survey.id)}} className="font-medium text-red-600 dark:text-red-500 hover:underline">Supprimer</a>
                    </div>
                  </td>
                )}
              </tr>
            )
          })}
        </tbody>
      </table>
    </div>
  );

  if (selectedSurvey) {
    return (
      <div>
        <button onClick={() => setSelectedSurvey(null)} className="mb-4 p-2 bg-primary text-white rounded">
          ← Retour à la liste
        </button>
        <DetailsSurvey survey={selectedSurvey} />
      </div>
    );
  }

  return (
    <div>
      <div className='flex gap-4 justify-end items-start'>
        {isCoownership(user.user) && (
          <ShareButton text={TEXT_SHARE_SURVEY(user.user.userData.codeOwner)} designBox={false} />
        )}
        
        {rentalManagerCanMakeActionOnCoownership(user.user) && (
          <a href="#" onClick={() => setShowAddSurvey(true)} className="justify-end flex mb-4">
            <PrimaryButton type={"button"} value={"Ajouter un sondage"} loading={false} />
          </a>
        )}
        <AppDisplayPreview image={sondagesPreview} label="Aperçu des sondages dans l'application" />
      </div>

      {/* Onglets pour basculer entre les sondages actifs et terminés */}
      <div className="mb-6 border-b border-gray-200 dark:border-gray-700">
        <ul className="flex flex-wrap -mb-px text-sm font-medium text-center" id="default-tab" role="tablist">
          <li className="me-2" role="presentation">
            <button
              className={`inline-block p-4 border-b-2 rounded-t-lg ${
                activeTab === 'active'
                  ? 'text-blue-600 border-blue-600 dark:text-blue-500 dark:border-blue-500'
                  : 'border-transparent hover:text-gray-600 hover:border-gray-300 dark:hover:text-gray-400'
              }`}
              onClick={() => setActiveTab('active')}
              type="button"
              role="tab"
            >
              Sondages actifs ({activeSurveys.length})
            </button>
          </li>
          <li className="me-2" role="presentation">
            <button
              className={`inline-block p-4 border-b-2 rounded-t-lg ${
                activeTab === 'finished'
                  ? 'text-blue-600 border-blue-600 dark:text-blue-500 dark:border-blue-500'
                  : 'border-transparent hover:text-gray-600 hover:border-gray-300 dark:hover:text-gray-400'
              }`}
              onClick={() => setActiveTab('finished')}
              type="button"
              role="tab"
            >
              Sondages terminés ({finishedSurveys.length})
            </button>
          </li>
        </ul>
      </div>

      {loader ? (
        <Loader />
      ) : (
        <div>
          {activeTab === 'active' ? (
            activeSurveys.length > 0 ? (
              <SurveyTable surveys={activeSurveys} title="Sondages actifs" />
            ) : (
              <div className="text-center py-8 text-gray-500 dark:text-gray-400">
                Aucun sondage actif pour le moment.
              </div>
            )
          ) : (
            finishedSurveys.length > 0 ? (
              <SurveyTable surveys={finishedSurveys} title="Sondages terminés" />
            ) : (
              <div className="text-center py-8 text-gray-500 dark:text-gray-400">
                Aucun sondage terminé pour le moment.
              </div>
            )
          )}
        </div>
      )}

      {showAddSurvey ? (
        <AddSurvey onClose={() => setShowAddSurvey(false)} />
      ) : null }

      {showUpdateSurvey ? (
        <UpdateSurvey onClose={() => setShowUpdateSurvey(false)} data={elementToUpdate} />
      ) : null } 

      {showArchiveModal ? (
        <DeleteModal type='delete' closeAction={() => setShowArchiveModal(false)} confirmAction={() => archiveSurvey()}/>
      ) : null }
    </div>
  );
};

export default ListSurveys;
